export default "__VITE_ASSET__BLt6r432__"